import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { IAverageTransactionValueApiService } from './average-transaction-value-api.interface';
import { SALES_ANALYTICS_API_URL } from '../sales-analytics-api.constants';
import { SuccessResponse } from '../../../shared/success-response';
import { ExportExcelPdfService } from '../../../export-excel-pdf/export-excel-pdf.service';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { ExportAvgTransactionValueQueryDto } from './dtos/export-avg-transaction-value.query.dto';
import { FindAvgTransactionValueQueryDto } from './dtos/find-avg-transaction-value.query.dto';
import { FindAvgTransactionValueResponseDto } from './dtos/find-avg-transaction-value.response.dto';

@Injectable({
  providedIn: 'root',
})
export class AverageTransactionValueApiService
  implements IAverageTransactionValueApiService
{
  private readonly ENDPOINT = 'average-transaction-value';

  private http = inject(HttpClient);
  private exportService = inject(ExportExcelPdfService);

  async findAverageTransactionValue(
    query: FindAvgTransactionValueQueryDto
  ): Promise<FindAvgTransactionValueResponseDto> {
    const params = new HttpParams({ fromObject: query as any });

    const response = await firstValueFrom(
      this.http.get<SuccessResponse<FindAvgTransactionValueResponseDto>>(
        `${SALES_ANALYTICS_API_URL}/${this.ENDPOINT}`,
        { params }
      )
    );

    return response.data;
  }

  exportAverageTransactionValue(
    query: ExportAvgTransactionValueQueryDto,
    options?: HandleBlobHttpResponseOptions
  ) {
    const { print = false } = options ?? {};
    const params = new HttpParams({ fromObject: query as any });

    this.exportService.export({
      endpoint: this.ENDPOINT,
      params,
      print,
    });
  }
}
